import { RequestMiddleware, ResponseContext, ResponseMiddleware, RetryableRequest } from "./types";

export const composeRequestPipeline = (middlewares: RequestMiddleware[]) =>
    (request: RetryableRequest): Promise<RetryableRequest> => {
        const dispatch = (i: number, req: RetryableRequest): Promise<RetryableRequest> =>
            i === middlewares.length
                ? Promise.resolve(req)
                : middlewares[i](req, (next) => dispatch(i + 1, next));

        return dispatch(0, request);
    };


export const composeResponsePipeline = (middlewares: ResponseMiddleware[]) =>
    (ctx: ResponseContext): Promise<ResponseContext> => {
        const dispatch = (i: number, ctx: ResponseContext): Promise<ResponseContext> =>
            i === middlewares.length
                ? Promise.resolve(ctx)
                : middlewares[i](ctx, (next) => dispatch(i + 1, next))

        return dispatch(0, ctx);
    };